import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community"; // Import Ag-Grid modules
import AuthLayout from "./layouts/Auth.js";
import AdminLayout from "./layouts/Admin.js";
import "./styles/base/AppBackground.css";

import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme.js";
ModuleRegistry.registerModules([AllCommunityModule]);

ReactDOM.render(
  <ChakraProvider theme={theme} resetCss={false}>
    <HashRouter>
      <Switch>
        <Route path={`/auth`} component={AuthLayout} />
        <Route path={`/admin`} component={AdminLayout} />
        <Redirect from={`/`} to="/auth/signin" />
      </Switch>
    </HashRouter>
  </ChakraProvider>,
  document.getElementById("root")
);